import { Component, OnInit, Output, EventEmitter, Input, Renderer2, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
// import { UtilityService } from 'src/app/services/utility.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuickGuideComponent } from '../quick-guide/quick-guide.component';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from 'src/app/shared/utils/utility.service';
// import { AmplitudeService } from 'src/app/services/amplitude.service';
declare var Android;

@Component({
  selector: 'app-audio-response',
  templateUrl: './audio-response.component.html',
  styleUrls: ['./audio-response.component.css']
})
export class AudioResponseComponent implements OnInit, OnDestroy {
  @Output() responseUrl = new EventEmitter<String>();
  @Output() recordingStarted = new EventEmitter<Boolean>(false);
  @Input() isSubmitted: boolean = false;
  @Input() set url(val: any) {
    this.source = val;
  }
  @Input() recorderId: string;
  @Input()
  set stopCameraTag(value) {
    if (value && value.stop) {
      if (this.cameraTagStop) {
        this.cameraTagStop();
      }
    }
  }
  @ViewChild('cameraTagIFrame') cameraTagIFrame: HTMLIFrameElement;
  fileList: any = [];
  invalidFileList: any = [];
  extension: string
  showDeleteModal: boolean = false;
  showProgress: boolean = false;
  source: any = null;
  progress: number = 0;
  deviceInfo;
  showRecorder: boolean = false;

  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e.data.for == this.recorderId) {
      console.log(e);
      this.source = e.data.data;
      this.responseUrl.emit(this.source);
      this.recordingStarted.emit(false);
      this.showRecorder = false;
    }
  }
  isAndroidApp = false;
  constructor (private utitlityService: UtilityService,/* private amplitude: AmplitudeService, */private renderer: Renderer2, private deviceService: DeviceDetectorService, private modalService: NgbModal, private toaster: ToastrService) { }

  ngOnInit() {
    this.isAndroidApp = /android/i.test(navigator.userAgent) && /wv/i.test(navigator.userAgent);
    this.epicFunction();
  }
  onFilesChange(fileList: Array<File>) {
    this.fileList = fileList;
    if (this.fileList.length == 1) {
      const file = this.fileList[0];
      this.extension = file.name.split('.')[file.name.split('.').length - 1];
      if (!(this.extension == 'mp3' || this.extension == 'wav' || this.extension == 'amr')) {
        this.toaster.warning("Invalid File Type");
        this.fileList = [];
        return false;

      }

      let formData = new FormData();
      formData.append('resources', file);

      this.showProgress = true;
      this.recordingStarted.emit(true);
      this.utitlityService.uploadFile(formData).subscribe(url => {
        this.responseUrl.emit(url);
        this.recordingStarted.emit(false);
        this.progress = 100;
        this.source = url;
      });
    }
  }
  filesInvalidEmiter(fileList: Array<File>) {
    this.invalidFileList = fileList;
  }

  hide() {
    this.showDeleteModal = false;
  }

  delete() {
    this.fileList = [];
    this.source = null;
    this.progress = 0;
    this.responseUrl.emit('');
    this.hide();
  }

  show() {
    this.showDeleteModal = true;
  }

  runR() {
    if(this.isAndroidApp) {
      Android.recordFile('audio');
      return;
    }
    this.showRecorder = true;
  }

  ngOnDestroy() {

  }

  load() {
    //  alert('allScriptLoaded');
    this.recordingStarted.emit(true);
  }


  reset() {
    this.fileList = [];
    this.source = null;
    this.progress = 0;
    this.recordingStarted.emit(false);
    this.showRecorder = false;
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    // console.log(this.deviceInfo);
    // console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    // console.log(isTablet);  // returns if the device us a tablet (iPad etc)
    // console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
  }

  cameraTagStop() {
    if (this.cameraTagIFrame) {
      let src = this.cameraTagIFrame.src;
      this.cameraTagIFrame.src = src;
    }
  }

  openQuickGuide() {
    let data = {
      deviceInfo: (this.deviceService.isDesktop()) ? 'desktop' : (this.deviceService.isMobile()) ? 'mobile' : 'other'
    }
    const modalRef = this.modalService.open(QuickGuideComponent, { size: 'lg' });
    modalRef.componentInstance.data = data;
    // this.amplitude.logEvent('User clicks on Audio Guide',{});
  }

  get isMobile() {
    return /Harappa Education\/[0-9\.]+$/.test(navigator.userAgent);
  }
  /**
   * Android webview get file path and set answer
   */
sendRecordFilePath() {
  let filePath = localStorage.getItem('fileStr');
  if(filePath && filePath.trim() != '') {
    localStorage.removeItem('fileStr');
    this.responseUrl.emit(filePath);
    this.recordingStarted.emit(false);
    this.progress = 100;
    this.source = filePath;
  }
}
}

